import { render } from "./PublicDashboard.vue?vue&type=template&id=62d94c1b"
import script from "./PublicDashboard.vue?vue&type=script&lang=js"
export * from "./PublicDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/diekstra/PhpstormProjects/rbs-vlb-reservations/rvr-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__